var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Card",
        [
          _vm.innerSpin
            ? _c("Spin", { attrs: { size: "large", fix: "" } })
            : _vm._e(),
          _c(
            "transition",
            { attrs: { name: "fade" } },
            [
              _vm.mainTable.sarchCardShow
                ? _c(
                    "Row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "24" } },
                        [
                          _c("search-card", {
                            attrs: {
                              form: _vm.mainTable.searchForm,
                              "table-load-event": _vm.getPromotionTableRecords,
                              "table-search": _vm.mainTable.tableSearch,
                              colSpan: 4,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c("Col", { attrs: { span: "24" } }, [
                _c("div", { staticClass: "global-tool-bar" }, [
                  _c("div", { staticClass: "left-bar" }, [
                    _c("span", { staticClass: "title" }, [
                      _vm._v("商品优惠管理"),
                    ]),
                  ]),
                  _c("div", { staticClass: "right-bar" }, [
                    _vm.$checkAccessArray(["B"])
                      ? _c(
                          "div",
                          [
                            _c(
                              "Button",
                              {
                                staticClass: "btns",
                                attrs: {
                                  size: "small",
                                  shape: "circle",
                                  icon: "md-arrow-down",
                                },
                                on: { click: _vm.onExport },
                              },
                              [_vm._v("导出")]
                            ),
                            _c(
                              "Button",
                              {
                                staticClass: "btns",
                                attrs: {
                                  size: "small",
                                  shape: "circle",
                                  type: "success",
                                  icon: "ios-add-circle-outline",
                                },
                                on: { click: _vm.onCreate },
                              },
                              [_vm._v("新增")]
                            ),
                            _c(
                              "Button",
                              {
                                staticClass: "btns",
                                attrs: {
                                  size: "small",
                                  shape: "circle",
                                  type: "warning",
                                  icon: "ios-add-circle-outline",
                                },
                                on: { click: _vm.onBatchCreate },
                              },
                              [_vm._v("批量新增")]
                            ),
                            _c(
                              "Button",
                              {
                                staticClass: "btns",
                                attrs: {
                                  size: "small",
                                  shape: "circle",
                                  type: "info",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.onActive(1)
                                  },
                                },
                              },
                              [_vm._v("启用")]
                            ),
                            _c(
                              "Button",
                              {
                                staticClass: "btns",
                                attrs: {
                                  size: "small",
                                  shape: "circle",
                                  type: "error",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.onActive(0)
                                  },
                                },
                              },
                              [_vm._v("停用")]
                            ),
                            _c(
                              "Button",
                              {
                                staticClass: "btns",
                                attrs: {
                                  size: "small",
                                  shape: "circle",
                                  type: "info",
                                  ghost: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.onPublic(1)
                                  },
                                },
                              },
                              [_vm._v("公开")]
                            ),
                            _c(
                              "Button",
                              {
                                staticClass: "btns",
                                attrs: {
                                  size: "small",
                                  shape: "circle",
                                  type: "error",
                                  ghost: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.onPublic(0)
                                  },
                                },
                              },
                              [_vm._v("不公开")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      [
                        _c(
                          "Button",
                          {
                            staticClass: "btns",
                            attrs: {
                              type: "primary",
                              size: "small",
                              shape: "circle",
                              icon: "ios-search",
                            },
                            on: {
                              click: function ($event) {
                                _vm.mainTable.sarchCardShow =
                                  !_vm.mainTable.sarchCardShow
                              },
                            },
                          },
                          [_vm._v("搜索")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c("stand-pagination-table", {
                    ref: "promotionTable",
                    attrs: {
                      columns: _vm.mainTable.columns,
                      data: _vm.mainTable.data,
                      loading: _vm.mainTable.loading,
                      "table-search": _vm.mainTable.tableSearch,
                      "table-load-event": _vm.getPromotionTableRecords,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: { title: "商品优惠信息", width: "600" },
          model: {
            value: _vm.promotionForm.show,
            callback: function ($$v) {
              _vm.$set(_vm.promotionForm, "show", $$v)
            },
            expression: "promotionForm.show",
          },
        },
        [
          _c(
            "Form",
            {
              ref: "promotionForm",
              attrs: { model: _vm.promotionForm, "label-position": "top" },
            },
            [
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _vm.promotionForm.type === "single"
                    ? _c(
                        "Col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "FormItem",
                            { attrs: { label: "商品信息" } },
                            [
                              _c(
                                "Select",
                                {
                                  attrs: { filterable: "" },
                                  model: {
                                    value:
                                      _vm.promotionForm.promotionProductUuid,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.promotionForm,
                                        "promotionProductUuid",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "promotionForm.promotionProductUuid",
                                  },
                                },
                                _vm._l(_vm.productList, function (item) {
                                  return _c(
                                    "Option",
                                    {
                                      key: item.productUuid,
                                      attrs: { value: item.productUuid },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.productCode +
                                            "-" +
                                            item.productName
                                        )
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c(
                        "Col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "FormItem",
                            { attrs: { label: "商品信息" } },
                            [
                              _c(
                                "Select",
                                {
                                  attrs: { filterable: "", multiple: "" },
                                  model: {
                                    value:
                                      _vm.promotionForm.promotionProductUuids,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.promotionForm,
                                        "promotionProductUuids",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "promotionForm.promotionProductUuids",
                                  },
                                },
                                _vm._l(_vm.productList, function (item) {
                                  return _c(
                                    "Option",
                                    {
                                      key: item.productUuid,
                                      attrs: { value: item.productUuid },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.productCode +
                                            "-" +
                                            item.productName
                                        )
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "是否启用" } },
                        [
                          _c(
                            "RadioGroup",
                            {
                              model: {
                                value: _vm.promotionForm.promotionEnable,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.promotionForm,
                                    "promotionEnable",
                                    $$v
                                  )
                                },
                                expression: "promotionForm.promotionEnable",
                              },
                            },
                            [
                              _c("Radio", { attrs: { label: 1 } }, [
                                _vm._v("启用"),
                              ]),
                              _c("Radio", { attrs: { label: 0 } }, [
                                _vm._v("停用"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "是否公开" } },
                        [
                          _c(
                            "RadioGroup",
                            {
                              model: {
                                value: _vm.promotionForm.promotionPublic,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.promotionForm,
                                    "promotionPublic",
                                    $$v
                                  )
                                },
                                expression: "promotionForm.promotionPublic",
                              },
                            },
                            [
                              _c("Radio", { attrs: { label: 1 } }, [
                                _vm._v("公开"),
                              ]),
                              _c("Radio", { attrs: { label: 0 } }, [
                                _vm._v("不公开"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "订购量" } },
                        [
                          _c("InputNumber", {
                            staticStyle: { width: "100%" },
                            attrs: { min: 0, "active-change": false },
                            model: {
                              value:
                                _vm.promotionForm.promotionQuantityThreshold,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.promotionForm,
                                  "promotionQuantityThreshold",
                                  $$v
                                )
                              },
                              expression:
                                "promotionForm.promotionQuantityThreshold",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "订购量优惠(元)" } },
                        [
                          _c("InputNumber", {
                            staticStyle: { width: "100%" },
                            attrs: { min: 0, "active-change": false },
                            model: {
                              value: _vm.promotionForm.promotionQuantityDisount,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.promotionForm,
                                  "promotionQuantityDisount",
                                  $$v
                                )
                              },
                              expression:
                                "promotionForm.promotionQuantityDisount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "订购额(元)" } },
                        [
                          _c("InputNumber", {
                            staticStyle: { width: "100%" },
                            attrs: { min: 0, "active-change": false },
                            model: {
                              value: _vm.promotionForm.promotionValueThreshold,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.promotionForm,
                                  "promotionValueThreshold",
                                  $$v
                                )
                              },
                              expression:
                                "promotionForm.promotionValueThreshold",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "订购额优惠(元)" } },
                        [
                          _c("InputNumber", {
                            staticStyle: { width: "100%" },
                            attrs: { min: 0, "active-change": false },
                            model: {
                              value: _vm.promotionForm.promotionValudeDiscount,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.promotionForm,
                                  "promotionValudeDiscount",
                                  $$v
                                )
                              },
                              expression:
                                "promotionForm.promotionValudeDiscount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "付定金比例(%)" } },
                        [
                          _c("InputNumber", {
                            staticStyle: { width: "100%" },
                            attrs: { min: 0, "active-change": false },
                            model: {
                              value:
                                _vm.promotionForm.promotionDepositThreshold,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.promotionForm,
                                  "promotionDepositThreshold",
                                  $$v
                                )
                              },
                              expression:
                                "promotionForm.promotionDepositThreshold",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "付定金优惠(元)" } },
                        [
                          _c("InputNumber", {
                            staticStyle: { width: "100%" },
                            attrs: { min: 0, "active-change": false },
                            model: {
                              value: _vm.promotionForm.promotionDepositDiscount,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.promotionForm,
                                  "promotionDepositDiscount",
                                  $$v
                                )
                              },
                              expression:
                                "promotionForm.promotionDepositDiscount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "提前预订天数(天)" } },
                        [
                          _c("InputNumber", {
                            staticStyle: { width: "100%" },
                            attrs: { min: 0, "active-change": false },
                            model: {
                              value: _vm.promotionForm.bookAheadDays,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.promotionForm,
                                  "bookAheadDays",
                                  $$v
                                )
                              },
                              expression: "promotionForm.bookAheadDays",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "预订优惠(元)" } },
                        [
                          _c("InputNumber", {
                            staticStyle: { width: "100%" },
                            attrs: { min: 0, "active-change": false },
                            model: {
                              value: _vm.promotionForm.bookDiscount,
                              callback: function ($$v) {
                                _vm.$set(_vm.promotionForm, "bookDiscount", $$v)
                              },
                              expression: "promotionForm.bookDiscount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                { attrs: { type: "primary" }, on: { click: _vm.onSave } },
                [_vm._v("确认")]
              ),
              _c(
                "Button",
                { attrs: { type: "error" }, on: { click: _vm.onCancel } },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }